// extracted by mini-css-extract-plugin
export default {"content":"lTX_j dialog-content","text":"n0JU5","error":"cBs2k","progress":"zjS2A","buttons":"qTNCd dialog-actions"};